import { render, staticRenderFns } from "./changePassThird.vue?vue&type=template&id=6b487962&"
import script from "./changePassThird.vue?vue&type=script&lang=js&"
export * from "./changePassThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports